<template>
<div>
    <section class="section-border border-primary">
        <div class="container d-flex flex-column">
            <div class="row align-items-center justify-content-center gx-0 min-vh-100">
                <div class="col-8 col-md-6 col-lg-7 offset-md-1 order-md-2 mt-auto mt-md-0 pt-12 pb-4 py-md-11">
                    <img src="/assets/img/illustrations/illustration-8.png" alt="Complete Telegram registration" class="img-fluid">
                </div>
                <div class="col-12 col-md-5 col-lg-4 order-md-1 mb-auto mb-md-0 pb-8 py-md-11">
                    <h1 class="mb-0 fw-bold text-center">Complete Registration</h1>
                    <p class="mb-4 text-center text-muted">
                        Enter your email to finish signing up
                    </p>
                    <p class="mb-6 text-center text-success fw-bold">
                        <i class="fe fe-gift me-2"></i>{{ $state.context.free_requests || 100 }} free requests — no extra verification needed!
                    </p>
                    <p class="mb-6 text-center text-danger" v-for="error in errors.__all__" :key="error">{{ error }}</p>
                    <form class="mb-6" @submit.prevent="complete">
                        <div class="form-group mb-5">
                            <label class="form-label">Email</label>
                            <input type="email" class="form-control" placeholder="Enter your Email"
                                :class="{'is-invalid': errors.email}" v-model="form.email">
                            <small class="form-text text-danger" v-for="error in errors.email" :key="error">{{ error }}</small>
                        </div>
                        <div class="form-group mb-5 fs-sm">
                            <label class="d-block" :class="{'is-invalid': errors.agree_terms_of_service}">
                                <input type="checkbox" class="form-check-input" v-model="form.agree_terms_of_service">
                                I accept the
                                <a href="/help/terms-of-service">Terms of service</a>
                            </label>
                            <label class="d-block" :class="{'is-invalid': errors.agree_privacy_policy}">
                                <input type="checkbox" class="form-check-input" v-model="form.agree_privacy_policy">
                                I accept the
                                <a href="/help/privacy-policy">Privacy Policy</a>
                            </label>
                        </div>
                        <button class="btn w-100 btn-primary" type="submit" :disabled="disabled">Complete Registration</button>
                    </form>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import { EventBus } from "@/bus";
import { displayErrors } from "utils/string"
import { safeNext, navigateToNext } from "utils/redirect"
export default {
    data() {
        return {
            form: {
                email: "",
                agree_terms_of_service: true,
                agree_privacy_policy: true
            },
            errors: {},
            disabled: false
        }
    },
    methods: {
        complete() {
            this.disabled = true
            this.errors = {}
            if (this.$state.context.promocode) {
                this.form.promocode = this.$state.context.promocode
                this.form.referrer = this.$state.context.referrer
            } else {
                this.form.promocode = localStorage.getItem("promocode")
                this.form.referrer = localStorage.getItem("referrer")
            }
            this.$services.TgComplete().save(this.form).then(resp => {
                this.errors = {}
                // Linking Telegram to an EXISTING account goes through the same
                // login path, so it can answer tfa_required (state=false) — a new
                // account never does. Keep ?next= for the OAuth consent round-trip.
                if (resp.body.message === 'tfa_required') {
                    this.disabled = false
                    const tfaNext = safeNext(this.$route.query.next)
                    const query = {step: 'tfa'}
                    if (tfaNext) query.next = tfaNext
                    return this.$router.push({path: '/login', query})
                }
                if (resp.body.state) {
                    EventBus.emit('context:changed')
                    const next = safeNext(this.$route.query.next)
                    setTimeout(() => {
                        if (!next) {
                            this.$router.replace({path: '/dashboard'})
                            return
                        }
                        navigateToNext(this.$services, next).catch(err => {
                            displayErrors(err, this)
                            this.disabled = false
                        })
                    })
                }
                displayErrors(resp, this)
                this.disabled = false
            }).catch(resp => {
                displayErrors(resp, this)
                this.disabled = false
            })
        }
    }
}
</script>
<style scoped>
label.is-invalid { color: red }
.is-invalid a { color: brown }
</style>
